import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { usePolicy } from '../contexts/PolicyContext'
import Asset from '../types/Asset'
import { deleteAssetPhoto } from '../services/assetService'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import Delete from '@mui/icons-material/Delete'
import LoadingButton from '@mui/lab/LoadingButton'
import { createErrorNotification, createSuccessNotification } from '../redux/slices/notifications'

export interface AssetPhotoDeleteButtonProps {
  asset: Asset
  onUpdate?: (asset: Asset) => void
}

export default function AssetPhotoDeleteButton({ asset, onUpdate }: AssetPhotoDeleteButtonProps) {
  const { t } = useTranslation('asset')

  const { canEditAsset } = usePolicy()

  const dispatch = useDispatch()

  const [loading, setLoading] = useState<boolean>(false)

  async function deletePhoto() {
    try {
      setLoading(true)

      await deleteAssetPhoto(asset.id)

      onUpdate?.({
        ...asset,
        photo: null,
        photoId: null,
        photoUrl: null
      })
      dispatch(createSuccessNotification(t('deletePhotoSuccess')))
    } catch {
      dispatch(createErrorNotification(t('deletePhotoError')))
    } finally {
      setLoading(false)
    }
  }

  if (!canEditAsset(asset)) {
    return null
  }

  return (
    <>
      <Tooltip title={t('deletePhoto')}>
        <LoadingButton
          component={IconButton}
          color="error"
          size="small"
          loading={loading}
          onClick={deletePhoto}
          sx={{ borderRadius: '50%', p: 2, minWidth: 0 }}
        >
          <Delete />
        </LoadingButton>
      </Tooltip>
    </>
  )
}
